<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('sensory.template.serialNo')" prop="templateNo">
              <el-input class="handle-input" v-model.trim="queryCondition.templateNo" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('sensory.template.status')" prop="status">
              <ic-select v-model="queryCondition.status" table="TT_SENSORY_TEMPLATE" field="STATUS" clearable style="width:100%"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('sensory.template.name')" prop="templateName">
              <el-input class="handle-input" v-model="queryCondition.templateName" clearable style="width:100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" v-acl="Sensory-templateAdd" @click="addTemplate()">{{$t('sensory.template.createNew')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Sensory-templateExport" @click="exportData">{{$t('base.linePrice.export')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Sensory-templateCopy" @click="copy">{{$t('sensory.template.copy')}}</el-button>
      <el-button size="mini" class='btn' type="primary" @click="onDel" v-acl="Sensory-templateDelete">删除</el-button>
      <el-button size="mini" class='btn' type="primary" @click="onActive('PASS')" v-acl="Sensory-templateActive">启用</el-button>
      <el-button size="mini" class='btn' type="primary" @click="onActive('DISABLE')" v-acl="Sensory-templateDisable">禁用</el-button>

    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column width="56px" :label="$t('common.select')" align="center">
        <template slot-scope="scope">
          <el-radio v-model.trim="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttSensoryTemplateId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="templateNo" :label="$t('sensory.template.serialNo')">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row.ttSensoryTemplateId)">{{scope.row.templateNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="templateName" :label="$t('sensory.template.name')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="remark" min-width="180px" :label="$t('sensory.template.remarks')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="version" min-width="180px" label="版本号"></el-table-column>
      <el-table-column show-overflow-tooltip prop="status" :label="$t('sensory.template.status')">
        <template slot-scope="scope">{{scope.row.status | ic("TT_SENSORY_TEMPLATE","STATUS")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="creator" :label="$t('visitPlan.CreateUser')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('visitPlan.CreateDate')">
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showTemplateNameDialog" width="80%" title="产品选择器">
      <PickupFiveBitCode @pickup="selectTemplateName" :multi='true'></PickupFiveBitCode>
    </el-dialog>
  </div>
</template>

<script>
import PickupFiveBitCode from "@/components/page/sensory/sensory-template/templateName";
import commonFunction from "@/utils/dataTableUtils";
import { templateList, copyInit, exportExcel, activeTemplate, deleteTemplateForDraft } from "@/api/sensory/template";
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index';
import paginationMixin from '@/mixins/pagitionMixin';
export default {
  mixins: [paginationMixin],
  components: { IcSelect, PickupFiveBitCode },
  extends: commonFunction,
  data() {
    return {
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        templateNo: '',
        templateName: '',
        status: '',
      },
      showTemplateNameDialog: false,
      totalCount: 0,
      tableList: [],
      radioVal: null,
      selectRow: null
    };
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.queryCondition = to.meta.reqData;
      vm.queryData(1);
    })
  },
  created() {
    //this.queryData(1);
  },
  methods: {
    onDel() {
      console.log('this.selectRow', this.selectRow);
      if (this.selectRow.status !== 'DRAFT') {
        this.$message.error("业务数据错误：请确认勾选的数据状态都为草稿!")
        return false
      }
      this.$confirm('是否确定删除此条数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTemplateForDraft(this.selectRow.ttSensoryTemplateId).then(resp => {
          console.log("🚀 ~ file: sensoryReportList.vue ~ line 232 ~ report.deleteReportForDraft ~ resp", resp)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.radioVal = ''
          this.queryData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onActive(status) {
      console.log('this.selectRow', this.selectRow);
      // 针对审核通过PASS的模板，可使用禁用按钮禁用DISABLE点击时“提示：请确认是否禁用”，如果状态不是审批通过状态则提示：仅可禁用状态为"审批通过"的品评模板，请检查!
      if (status === 'DISABLE') {
        if (this.selectRow.status !== 'PASS') {
          this.$message.error("仅可禁用状态为审批通过的品评模板，请检查!")
          return false
        }
        this.$confirm('提示：请确认是否禁用?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendReq(status)
        }).catch((err) => {
          console.log("🚀 ~ file: sensoryTemplateList.vue ~ line 151 ~ onActive ~ err", err)
          this.$message({
            type: 'info',
            message: '已取消禁用'
          });
        });
        // 针对已禁用的模板，可使用启用按钮重新启用，如果状态不是已禁用状态则提示：仅可启用状态为"已禁用"的品评模板，请检查！
      } else if (status === 'PASS') {
        if (this.selectRow.status !== 'DISABLE') {
          this.$message.error("仅可启用状态为已禁用的品评模板，请检查！")
          return false
        }
        this.sendReq(status)
      }
    },
    sendReq(status) {
      activeTemplate(this.selectRow.ttSensoryTemplateId, status).then(resp => {
        console.log("🚀 ~ file: sensoryReportList.vue ~ line 232 ~ report.deleteReportForDraft ~ resp", resp)
        this.$message({
          type: 'success',
          message: status === 'DISABLE' ? "禁用成功" : "启用成功"
        });
        this.radioVal = ''
        this.queryData()
      })
    },
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      templateList(this.queryCondition).then(res => {
        that.tableList = res.data.records;
        that.totalCount = res.data.total;
      });
    },
    //单选操作
    getSelectRow(row) {
      console.log("🚀 ~ file: sensoryTemplateList.vue ~ line 189 ~ getSelectRow ~ row", row)
      this.selectRow = [];
      this.selectRow = row;
    },
    toDetail(ttSensoryTemplateId) {
      if (this.actionCheck.actionCheck('Sensory-templateDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      let resolve = this.$router.resolve({
        path: `/sensoryTemplate-add`,
        query: { ttSensoryTemplateId: ttSensoryTemplateId }
      });
      window.open(resolve.href, "_blank");
    },
    exportData() {
      let that = this;
      if (this.selectRow == null) {
        that.$message({
          message: this.$t("common.pleaseSelectOneData"),
          type: "warning"
        });
      } else {
        let templateId = that.selectRow.ttSensoryTemplateId;
        exportExcel(templateId);
      }
    },
    getTemplateName() {
      this.showTemplateNameDialog = true;
    },
    selectTemplateName(data) {
      let that = this
      if (data.length > 0) {
        that.queryCondition.templateName = data.map(item => item.fiveBitCodeName).join(',');
      }
      // data.forEach((item) => {
      //     that.queryCondition.templateName=that.queryCondition.fiveBitCodeName+item.fiveBitCodeName+',';
      // });
      this.showTemplateNameDialog = false
    },
    copy() {
      let that = this;
      if (this.selectRow == null) {
        that.$message({
          message: this.$t("common.pleaseSelectOneData"),
          type: "warning"
        });
      } else {
        let templateId = that.selectRow.ttSensoryTemplateId;
        copyInit(templateId).then(res => {
          console.log(res);
          if (res.code == 200) {
            that.$message({
              message: this.$t("common.copySuccess"),
              type: "success"
            });
            that.queryData();
          }
        });
      }
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        templateNo: '',
        templateName: '',
        status: '',
      }
      this.radioVal = ''
      this.queryData()

    },
    addTemplate() {
      this.$router.push({
        path: `/sensoryTemplate-add`
      });
    }
  }
};
</script>
<style  lang="scss">
.el-tooltip__popper {
  max-width: 60%;
}
</style>
